import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Shared bottom CTA strip for marketing pages (matches Overview primary actions).
 */
export default function MarketingFooterCtas() {
  const { t } = useTranslation();

  return (
    <section className="marketing-section-card marketing-footer-ctas" aria-labelledby="marketing-footer-ctas-heading">
      <h2 id="marketing-footer-ctas-heading" className="marketing-section-title">
        {t("marketing_next_steps_title")}
      </h2>
      <p className="marketing-section-text mb-4">{t("marketing_next_steps_desc")}</p>
      <div className="marketing-cta-row">
        <Link to="/chatbot" className="marketing-cta">
          {t("overview_cta_chat")}
        </Link>
        <Link to="/Apps" className="marketing-cta marketing-cta--secondary">
          {t("overview_cta_apps")}
        </Link>
        <Link to="/Overview" className="marketing-cta marketing-cta--secondary">
          {t("overview")}
        </Link>
        <Link to="/Features" className="marketing-cta marketing-cta--secondary">
          {t("explore_features")}
        </Link>
        <Link to="/pricing" className="marketing-cta marketing-cta--secondary">
          {t("view_pricing")}
        </Link>
      </div>
    </section>
  );
}
